import React, { useState } from 'react';
import Bulb from '../assets/images/Bulb.png';
import { Link, useLocation } from 'react-router-dom'
import JobPosting from '../assets/images/JobPosting.png';
import '../styles/jobpost.css';
import LinkedIn from '../assets/images/LinkedIn.png'
import Amalgam from '../assets/images/Amalgam-logo.png'
import sendEmail from '../utils/sendEmail';
import { useMediaQuery } from 'react-responsive';

const defaultJob = {
    title: 'Sales & Marketing Intern (Remote)',
    description: 'Amalgam is seeking a qualified intern to support its marketing and sales efforts. Our selected candidate will have the opportunity to gain real time technical sales and marketing experience in an already well established, lean company while simultaneously learning the fundamentals of cloud-based services such as AWS. This experience will take many forms such as learning how to build marketing and sales materials, managing/help building a sales pipeline, and participating in new prospect and client meetings.',
    hours: "Full-time",
    pay: "$40,000-$60,000",
    duties: ['Shadow CEO, Sales Engineer, and supporting teams to gain insight into all aspects of the software development business.', 'Shadow and assist team members with customer presentations, quotations, sales calls, and other customer interactions.', 'Build and manage go-to-market sales materials such as case studies of previous work, amalgam\'s website, and Amalgam\'s blog.', 'Currently working on completion of a Bachelor\'s degree in marketing, finance, economics, computer science, psychology or other business related majors.', '15 flexible hours per week.', 'Ability to meet team members via video conferencing for occasional meetings 8a-7pm EST.']
};

function JobPost() {
    const location = useLocation();
    const job = location.state || defaultJob;
    const isMobile = useMediaQuery({ maxWidth: 570 });
    const isTablet = useMediaQuery({ maxWidth: 1100 });
    // Add state for form fields
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [linkedIn, setLinkedIn] = useState('');
    const [resume, setResume] = useState('');
    const [message, setMessage] = useState('');
    const [terms, setTerms] = useState(false);

    const handleSubmitApplication = async (e: React.FormEvent) => {
        e.preventDefault();

        // Create formatted email message
        const emailBody = `
            New Job Application for: ${job?.title}

            Applicant Details:
            -----------------
            Name: ${firstName} ${lastName}
            Email: ${email}
            LinkedIn: ${linkedIn}
            Resume Link: ${resume}

            Additional Message:
            -----------------
            ${message}

            Job Details:
            -----------
            Position: ${job?.title}
            Hours: ${job?.hours}
            Pay: ${job?.pay}
            `;

        console.log(emailBody);

        const result = await sendEmail(
            `${firstName} ${lastName}`,
            email,
            emailBody
        );

        if (result.success) {
            alert('Application submitted successfully!');
        } else {
            alert(`Failed to submit application: ${result.error}`);
        }
    };

    return (
        <div style={{ position: "relative", zIndex: 1 , backgroundColor: "white"}}>
            <section className='careers-row-1'>
                <h1>Amalgamate with us</h1>
                <p>Explore exciting career opportunities and become part of our success story.</p>
            </section>
            <section className='jobpost-row-2'>
                <img src={Bulb} alt="Bulb" className='jobpost-bulb' />
                <h1>{job?.title} </h1>
                <p>{job?.hours}<br />{job?.pay}</p>
            </section>
            <section className='jobpost-row-3'>
                <div>
                    <h1 className=''>Role overview</h1>
                    <div className='jobpost-role-descriptions'>
                        {job.duties.map((duty: string, index: number) => {
                            return <p key={index}>{duty}</p>
                        })}
                    </div>
                </div>
                <img src={JobPosting} alt="JobPosting" className='jobpost-jobposting' />
            </section>


            <section className='jobpost-row-4'>
                <h1>Apply now</h1>

                <form className='jobpost-form' onSubmit={handleSubmitApplication} style={{ maxWidth: '100%', padding: '0 16px' }}>
                    <div className='jobpost-form-div'>
                        <div>
                            <label>First Name *</label>
                            <input
                                type="text"
                                id="firstName"
                                required
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                style={{ width: '100%' }}
                            />
                        </div>
                        <div>
                            <label htmlFor="lastName">Last Name *</label>
                            <input
                                type="text"
                                id="lastName"
                                required
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                style={{ width: '100%' }}
                            />
                        </div>
                    </div>
                    <div className='jobpost-form-div'>
                        <div>
                            <label>Email *</label>
                            <input
                                type="email"
                                id="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                style={{ width: '100%' }}
                            />
                        </div>
                        <div>
                            <label>LinkedIn Profile</label>
                            <input
                                type="text"
                                id="linkedin"
                                placeholder="e.g., https://www.linkedin.com/in/username"
                                value={linkedIn}
                                onChange={(e) => {
                                    let url = e.target.value;
                                    // Add https:// if not present and user has entered something
                                    if (url && !url.startsWith('http')) {
                                        url = 'https://' + url;
                                    }
                                    setLinkedIn(url);
                                }}
                                style={{ width: '100%' }}
                            />
                        </div>
                    </div>
                    <div className='jobpost-form-div'>
                        <div id='resume'>
                            <label>Resume Link *</label>
                            <input
                                type="url"
                                id="resume"
                                value={resume}
                                onChange={(e) => setResume(e.target.value)}
                                style={{ width: '100%' }}
                            />
                        </div>
                    </div>
                    <div className='jobpost-form-div'>
                        <div className='jobpost-form-textarea'>
                            <label htmlFor="message">Message</label>
                            <textarea
                                id="message"
                                placeholder='Tell us why you would be a great fit for this position'
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                style={{ width: '100%' }}
                            ></textarea>
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: "center", padding: "10px" }}>
                        <input
                            type="checkbox"
                            id="terms"
                            required
                            checked={terms}
                            onChange={(e) => setTerms(e.target.checked)}
                        />
                        <label htmlFor="terms" style={{ marginLeft: '8px', }}>I accept the Terms *</label>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <button type="submit" className="jobpost-submit-button" style={{ border: "1px solid black", padding: "10px" }}>Submit </button>
                    </div>
                </form>
            </section>

            {!isTablet ? (
                <section className='home-footer'>
                    <div className='home-footer-middle'>
                        <img src={Amalgam} alt="Amalgam" className='home-footer-amalgam' />
                        <Link to="/" className='home-footer-links'>Home</Link>
                        <Link to="/ourwork" className='home-footer-links'>Our Work</Link>
                        <Link to="/aboutus" className='home-footer-links'>About Us</Link>
                        <Link to="/case-studies" className='home-footer-links'>Case Studies</Link>
                        <Link to="/startups" className='home-footer-links'>Launchpad</Link>
                        <Link to="/careers" className='home-footer-links'>Careers</Link>
                        <Link to="/contactus" className='home-footer-links'>Contact Us</Link>
                        <img src={LinkedIn} alt="Instagram" className='home-footer-linkedin' />
                    </div>
                    <div className='home-footer-dividor'>
                        <div className='home-footer-policies'>
                            <p><Link to="/privacy-policy">Privacy Policy</Link></p>
                            <p><Link to="/terms-and-conditions">Terms and Conditions</Link></p>
                            <p><Link to="/cookie-policy">Cookie Policy</Link></p>
                        </div>
                    </div>
                </section>
            ) : (
                <section>
                    <div className="footer-minimal">
                        <div className="footer-content">
                            {/* <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '20px' }}>
                                <img src={Amalgam} alt="Amalgam" className="footer-logo" />
                                <img src={LinkedIn} alt="Instagram" className='home-footer-linkedin' style={{ alignSelf: "center" }} />
                            </div> */}
                            <div className="footer-top-row">
                                <Link to="/" className="footer-link">Home</Link>
                                <span className="footer-separator">•</span>
                                <Link to="/ourwork" className="footer-link">Our Work</Link>
                                <span className="footer-separator">•</span>
                                <Link to="/aboutus" className="footer-link">About Us</Link>
                                <span className="footer-separator">•</span>
                                <Link to="/case-studies" className="footer-link">Case Studies</Link>
                            </div>
                            <div className="footer-bottom-row">
                                <Link to="/startups" className="footer-link">Launchpad</Link>
                                <span className="footer-separator">•</span>
                                <Link to="/careers" className="footer-link">Careers</Link>
                                <span className="footer-separator">•</span>
                                <Link to="/contactus" className="footer-link">Contact</Link>
                            </div>
                        </div>
                    </div>

                    <div style={{
                        width: "80%",
                        height: "0px",
                        borderTop: "1px solid black",
                        backgroundColor: "white",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "20px",
                        margin: "0 auto"
                    }}>
                    </div>
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "white",
                        gap: isMobile ? "5px" : "20px",
                        paddingBottom: "20px",
                        width: "100%",
                        padding: "0 10px 20px 10px",
                        textAlign: "center"
                    }}>
                        <Link to="/privacy-policy" style={{ textAlign: "center", color: "black", textDecoration: "none" }}>Privacy Policy</Link>
                        <span style={{ color: "black", fontSize: "14px" }}>|</span>
                        <Link to="/terms-and-conditions" style={{ color: "black", textDecoration: "none" }}>Terms and Conditions</Link>
                        <span style={{ color: "black", fontSize: "14px" }}>|</span>
                        <Link to="/cookie-policy" style={{ fontSize: "14px", color: "black", textDecoration: "none" }}>Cookie Policy</Link>
                    </div>
                </section>
            )}
        </div>
    );
}

export default JobPost;